import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegistrationWizard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue'),
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/ProfileView.vue'),
      },
      {
        path: 'learning',
        name: 'Learning',
        alias: '/learning-path',
        component: () => import('@/views/LearningView.vue'),
      },
      {
        path: 'opportunities',
        name: 'Opportunities',
        component: () => import('@/views/OpportunitiesView.vue'),
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/NotificationsView.vue'),
      },
      {
        path: 'commitments',
        name: 'Commitments',
        component: () => import('@/views/CommitmentsView.vue'),
      },
      {
        path: 'my-applications',
        name: 'MyApplications',
        alias: '/applications',
        component: () => import('@/views/MyApplicationsView.vue'),
      },
      {
        path: 'dev-plan',
        name: 'DevPlan',
        component: () => import('@/views/LearningPathTimelineView.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Auth guard
router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (to.meta.public) return true

  if (!auth.isAuthenticated) {
    // Attempt silent token refresh
    await auth.initSession()
    if (!auth.isAuthenticated) {
      return { name: 'Login', query: { redirect: to.fullPath } }
    }
  }

  return true
})
